module.exports = __webpack_public_path__ + "7fc6ca4345c4c457cbb2b95bad938ac4.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/trendarticle_1.jpg
// module id = 307
// module chunks = 0